import { render, staticRenderFns } from "./AccountUserSendMessages.vue?vue&type=template&id=35eea8e0&scoped=true"
import script from "./AccountUserSendMessages.vue?vue&type=script&lang=js"
export * from "./AccountUserSendMessages.vue?vue&type=script&lang=js"
import style0 from "./AccountUserSendMessages.vue?vue&type=style&index=0&id=35eea8e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eea8e0",
  null
  
)

export default component.exports